import { Crosshair, Ruler, Code2, ClipboardList, MessageSquareMore, ArrowRight } from "lucide-react";
import { STEPS } from "@/data/content";
import { Reveal } from "./Reveal";

const ICONS = { crosshair: Crosshair, ruler: Ruler, code: Code2, clipboard: ClipboardList, message: MessageSquareMore };

export const StepPath = () => (
  <section id="path" data-testid="five-step-path" className="grid gap-6 md:grid-cols-[200px_1fr] md:items-start">
    <Reveal>
      <h2 className="font-display text-[28px] font-bold leading-[1.15] tracking-tight text-[#0B1B33] md:text-[30px]">A practical 5&#8209;step project path</h2>
    </Reveal>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-5 sm:gap-1">
      {STEPS.map((s, i) => {
        const Icon = ICONS[s.icon];
        return (
          <Reveal key={s.title} delay={i * 0.09} className="relative">
            <div data-testid={`step-card-${i + 1}`} className="group flex items-start gap-4 sm:flex-col sm:items-center sm:text-center">
              <div className="relative shrink-0">
                <span className="absolute -left-3 -top-3 grid h-7 w-7 place-items-center rounded-full bg-[#0E9384] text-[13px] font-bold text-white shadow-md">{i + 1}</span>
                <span className="grid h-14 w-14 place-items-center rounded-2xl text-blue-700 transition-transform duration-300 group-hover:-translate-y-1 group-hover:rotate-3">
                  <Icon className="h-9 w-9" strokeWidth={1.7} />
                </span>
              </div>
              <div>
                <h3 className="font-display text-[18px] font-bold text-[#0B1B33] sm:mt-1">{s.title}</h3>
                <p className="mt-1 text-[14px] leading-snug text-slate-600">{s.text}</p>
              </div>
            </div>
            {i < 4 && <ArrowRight className="absolute -right-3 top-5 hidden h-5 w-5 text-[#0B1B33] sm:block" />}
          </Reveal>
        );
      })}
    </div>
  </section>
);
